import * as React from 'react';
import {
	ImageField,
	NumberField,
	ReferenceField,
	Show,
	ShowProps,
	SimpleShowLayout,
	TextField,
	UrlField
} from 'react-admin';
import { TranslateField } from '../components/TranslateField';

export const TrainingShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<ImageField source="featuredImageUrl" label="FEATURED_IMAGE"/>
				<TextField source="name" label="NAME"/>
				<TextField source="description" label="DESCRIPTION"/>
				<ReferenceField source="categoryId" reference="training-categories" label="CATEGORY">
					<TextField source="name"/>
				</ReferenceField>

				<UrlField source="videoUrl" label="YOUTUBE_LINK"/>
				<UrlField source="externalUrl" label="EXTERNAL_LINK"/>
				<UrlField source="iframeUrl" label="IFRAME_URL"/>
				<NumberField source="order" label="ORDER"/>
				<TranslateField source="language" label="LANGUAGE"/>
			</SimpleShowLayout>
		</Show>
	);
};
